module.exports = __webpack_public_path__ + "fa34319383a6a3faa458876cad31eeb8.png";


//////////////////
// WEBPACK FOOTER
// /src/public/img/evalve.png
// module id = 1993
// module chunks = 0